<template>
  <div>
    <!-- echarts区域 -->
    <div
      class="emotion"
      v-loading="loading"
      element-loading-background="rgba(16,164,178, 0.2)"
    >
      <!-- 左边区域 -->
      <div class="emotion_left" id="emotion"></div>
      <!-- 右边区域 -->
      <div class="emotion_right" id="mood"></div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import "echarts-wordcloud/dist/echarts-wordcloud";
import "echarts-wordcloud/dist/echarts-wordcloud.min";

export default {
  data() {
    return {
      loading: false,
      emotionData: [],
      text: "",
      emotionMood: [],
      mood: [],
    };
  },
  props: ["analyze"],
  components: {},
  computed: {},
  beforeMount() {},
  mounted() {
    this.emotion();
    this.Mood();
  },
  methods: {
    async emotion() {
      this.loading = true;
      let data = { content: this.analyze };
      const { data: res } = await this.$http.post("/nlpir/emotional", data);
      // console.log(res);
      this.loading = false;
      this.emotionData = res.data;
      this.text = res.sentiment;
      // 启动echarts
      this.echarts();
    },
    async Mood() {
      let data = { content: this.analyze };
      const { data: res } = await this.$http.post(
        "/nlpir/sentimentAnalysis",
        data
      );
      this.emotionMood = res.dataSentimentAnalysis;
      this.mood = res.data;
      // 启动echarts
      this.moodles();
    },
    echarts() {
      var color = ["#FC4567", "#2F8DF4", "#C25EC4"];
      var emotion_echarts = echarts.init(document.getElementById("emotion"));
      let option = {
        color: color,
        title: {
          text: this.text,
          left: "center",
          top: "50%",
          textStyle: {
            fontSize: 22,
            color: "#fff",
            fontWeight: "normal",
          },
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: 20,
          top: 20,
          textStyle: {
            color: "#fff",
          },
        },
        series: [
          {
            type: "pie",
            roseType: "radius",
            radius: ["30%", "60%"],
            data: this.emotionData,
            label: {
              normal: {
                formatter: "{font|{c}}\n{hr|}\n{font|{d}%}",
                rich: {
                  font: {
                    fontSize: 20,
                    padding: [5, 0],
                    color: "#fff",
                  },
                  hr: {
                    height: 0,
                    borderWidth: 1,
                    width: "100%",
                    borderColor: "#fff",
                  },
                },
              },
            },
            labelLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0,0,0,0.5)",
              },
            },
          },
        ],
      };
      emotion_echarts.setOption(option);
      window.onresize = function () {
        emotion_echarts.resize();
      };
    },
    moodles() {
      var pie_echarts = echarts.init(document.getElementById("mood"));
      let option = {
        // backgroundColor: "#0a1a2a",
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(0,0,0,0.9)",
          formatter: function (params) {
            return (
              params.seriesName +
              "<br/>" +
              params.marker +
              '<span style="color:' +
              params.color +
              '">' +
              params.data["name"] +
              "\n" +
              params.data["value"] +
              "</span>"
            );
          },
        },
        legend: {
          selectedMode: false,
          orient: "vertical",
          itemWidth: 8,
          itemHeight: 8,
          icon: "circle",
          right: "10",
          top: "center",
          textStyle: {
            fontSize: 14,
            color: "#6e69b2",
          },
          data: this.mood,
        },
        series: [
          {
            name: "",
            type: "pie",
            hoverAnimation: false,
            legendHoverLink: false,
            cursor: "default",
            radius: ["32%", "50%"],
            center: ["45%", "50%"],
            color: [
              "rgba(255,48,48, 1)",
              "rgba(255,130,71, 1)",
              "rgba(255,215,0, 1)",
              "rgba(79,148,205, 1)",
              "rgba(205,16,118, 1)",
              "rgba(107,142,35, 1)",
              "rgba(50,205,50, 1)",
            ],
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            zlevel: 1,
            itemStyle: {
              normal: {
                borderColor: "#0a1a2a",
              },
              ellipsis: {
                borderColor: "#0a1a2a",
              },
            },
            tooltip: {
              show: false,
            },
            data: this.emotionMood,
          },
          {
            name: "",
            type: "pie",
            zlevel: 2,
            cursor: "default",
            hoverAnimation: false,
            legendHoverLink: false,
            radius: ["37%", "50%"],
            center: ["45%", "50%"],
            color: [
              "rgba(255,48,48, 1)",
              "rgba(255,130,71, 1)",
              "rgba(255,215,0, 1)",
              "rgba(79,148,205, 1)",
              "rgba(205,16,118, 1)",
              "rgba(107,142,35, 1)",
              "rgba(50,205,50, 1)",
            ],
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              normal: {
                // shadowBlur: 15,
                // shadowColor: 'rgba(0, 0, 0, 0.5)',
                borderColor: "#0a1a2a",
                // borderWidth:'10',
              },
              ellipsis: {
                borderColor: "#0a1a2a",
              },
            },
            tooltip: {
              show: false,
            },
            data: this.emotionMood,
          },
          {
            name: "title",
            type: "pie",
            zlevel: 3,
            hoverAnimation: false,
            legendHoverLink: false,
            radius: ["43%", "50%"],
            center: ["45%", "50%"],
            color: [
              "rgba(255,48,48, 1)",
              "rgba(255,130,71, 1)",
              "rgba(255,215,0, 1)",
              "rgba(79,148,205, 1)",
              "rgba(205,16,118, 1)",
              "rgba(107,142,35, 1)",
              "rgba(50,205,50, 1)",
            ],
            label: {
              show: true,

              formatter: (params) => {
                return `
 ${params.name}: ${params.percent}%
 ${params.data.value}个
 `;
              },
              padding: [0, -30],
              textStyle: {
                lineHeight: 25,
              },
            },
            labelLine: {
              show: true,
              // showAbove:true,
              length: 30,
              length2: 50,
            },
            itemStyle: {
              shadowBlur: 15,
              shadowColor: "rgba(0, 0, 0, 0.3)",
              borderColor: "#0a1a2a",
            },
            data: this.emotionMood,
          },
        ],
      };
      pie_echarts.setOption(option);
      window.onresize = function () {
        pie_echarts.resize();
      };
    },
  },
  watch: {},
};
</script>
<style lang="less" scoped>
.emotion {
  width: 100%;
  height: 360px;
  box-sizing: border-box;
  .emotion_left {
    width: 50%;
    height: 360px;
    box-sizing: border-box;
    float: left;
  }
  .emotion_right {
    width: 48%;
    height: 360px;
    box-sizing: border-box;
    float: right;
    .emotionBox {
      width: 98%;
      height: 109px;
      border: 1px solid #fff;
      box-sizing: border-box;
      margin-top: 8px;
      margin-right: 10px;
      border-radius: 5px;
    }
  }
}
</style>
